import React from "react";
const rows = [
  [
    "Deposit assumption",
    (f) => (f.purchase?.inputs || f.cashflow?.inputs)?.deposit,
    "AUD",
  ],
  ["Purchase cash required", (f) => f.purchase?.costs.cash_needed, "AUD"],
  ["Cash-flow cash required", (f) => f.cashflow?.base.cash_needed, "AUD"],
  ["Weekly rent assumption", (f) => f.cashflow?.inputs.weekly_rent, "AUD"],
  ["Interest rate assumption", (f) => f.cashflow?.inputs.annual_rate_pct, "%"],
  ["Repayment type", (f) => f.cashflow?.inputs.repayment_type, "text"],
  ["Annual pre-tax cash flow", (f) => f.cashflow?.base.annual_cashflow, "AUD"],
  [
    "Break-even weekly rent",
    (f) => f.cashflow?.base.break_even_weekly_rent,
    "AUD",
  ],
];
function format(value, unit) {
  if (value === undefined) return "Not saved";
  if (value === null) return "Not achievable with these inputs";
  if (unit === "%") return `${value}%`;
  if (unit === "text") return String(value).replaceAll("_", " ");
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
  }).format(value);
}
export default function FinancialComparison({ reports }) {
  if (!reports.some((r) => r.finances)) return null;
  return (
    <>
      <h3>Compare saved financial scenarios</h3>
      <p>
        These historical scenarios may use different assumptions. Compare rent,
        financing and costs before comparing the outcomes. No figure is a market
        forecast.
      </p>
      <div className="table-scroll">
        <table aria-label="Financial scenario comparison">
          <thead>
            <tr>
              <th scope="col">Assumption or calculation</th>
              {reports.map((r) => (
                <th scope="col" key={r.id}>
                  {r.inputs.address}
                  <small>
                    Saved {new Date(r.created_at).toLocaleDateString("en-AU")}
                  </small>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, get, unit]) => (
              <tr key={label}>
                <th scope="row">{label}</th>
                {reports.map((r) => (
                  <td key={r.id}>{format(get(r.finances || {}), unit)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
